<template>
    <div class="detail">
        <div class="box_title">
            <div class="box_title_left">
                {{ name }}
            </div>
            <div class="box_title_right">
               <span class="el-icon-location-outline"></span> 当前位置:  <router-link to="/"> 首页 </router-link> /  {{ name }} 
            </div>
        </div>

        <div class="content_box">
            <div class="title">
                {{ info.newsTitle }}
            </div>
            <div class="desc">
                <div class="from item">
                    文章来源: {{ info.newsFromSrc }}
                </div>
                <div class="time item">
                    日期: {{ info.createTime }}
                </div>
                <div class="count item">
                    浏览: {{ info.readNum }}次
                </div>
                
            </div>
            <div class="details news_content">
                <div class="parsehtml" v-html="info.newsContent"></div>
            </div>

            <!-- 上一个 下一个 -->
            <div class="bottom_box">
                <div class="items pre" >
                    上一篇: <span v-if="preInfo.newsId"  @click="showNewsDetail( preInfo )" >{{ preInfo.newsTitle }}</span> <span v-else>没有了</span>
                </div>
                <div class="items next" >
                    下一篇: <span v-if="nextInfo.newsId" @click="showNewsDetail( nextInfo )">{{ nextInfo.newsTitle }}</span> <span v-else>没有了</span>
                </div>
            </div>

            <!-- 悬浮按钮 -->
            <div class="fixed_box">
                <div class="item"  v-for="(item, index) in iconList" 
                :key="index" :class="active === index ? 'active': ''  "
                @mouseover="MouseEnter( index )"
                @mouseout="MouseOut"
                @click="itemClick( index )"
                v-show="item.show"
                    >
                    <span :class="item.status == 1 ? item.activeClass : item.iconClass  "></span>
                    <span class="txt" v-if="item.count && item.count != '0' ">{{ item.count }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    import ClipboardJS from "clipboard"
    export default {
        data() {
            return {
                name: "新闻详情",
                content: `<div>这里是文章内容</div>`,
                iconList: [
                    { iconClass: "icon iconfont icon-shoucang gray", activeClass: "icon iconfont icon-shoucang red", count: 0, status: 0, show: false },
                    { iconClass: "icon iconfont icon-dianzan gray",activeClass: "icon iconfont icon-dianzan red", count: 0, status: 0, show: false },
                    { iconClass: "icon el-icon-share red",activeClass: "icon el-icon-share red", count: 0,status: 1, show: true },
                    { iconClass: "icon el-icon-top red",activeClass: "icon el-icon-top red", count: 0,status: 1, show: true },
                ],
                active: "",  
                shareUrl: "", // 分析那个的页面路径
            }
        },

        props: {
            info: Object,
            nextInfo: {
                type: Object,
                default: {}
            },
            preInfo: {
                type: Object,
                default: {}
            },
            isZan: {
                type: Number,
                default: 0
            },
            isCollect: {
                type: Number,
                default:0
            }
        },
        computed: {
            news_id () {
                return Number( this.$route.params.id)
            },
            ...mapGetters(['token'])
        },
        watch: {
            isZan () {
                console.log( this.isZan )
                this.formatData()
                console.log( this.iconList )
            },
            isCollect () {
                this.formatData()
            }
        },
        mounted() {
            this.formatData()
             
        },
        methods: {
            auth () {
                console.log("11")
                if ( this.token ) {
                    return true 
                } else {
                    return this.$confirm("请先登录", "提示",{type:"danger"})
                    .then( () => {
                        this.$router.push("/login")
                    })
                    .catch(() => {
                        // this.$router.push("/")
                    })
                }
            },
            // 鼠标进入事件
            MouseEnter ( index ) {
                this.active = index 
            },
            // 鼠标离开
            MouseOut () {
                this.active = ""
            },
            // 点击事件
            itemClick ( index ) {
                if (index == 3) {
                    this.scrollTop()
                } else if ( index == 0  ) {
                    this.collectNews()
                } else if ( index == 1  ) {
                    this.zanNews()
                } else if ( index == 2 ) {
                    this.shareNews()
                }
            },

            // 分享链接
            shareNews () {
                this.shareUrl = window.location.href
                const input = document.createElement('input');
                document.body.appendChild(input);
                input.setAttribute('value', this.shareUrl );
                input.select();
                if (document.execCommand('copy')) {
                    document.execCommand('copy');
                    this.$message.success("复制成功")
                }
                document.body.removeChild(input);
            },
            // 收藏
            async  collectNews () {
                console.log( this.token )
                if ( this.token ) {
                    let { token,news_id, isCollect } = this 
                    let reqUrl = isCollect == 0 ? "/lencon/pc/news/news_collection" : "/lencon/pc/news/cancel_collection"
                    let res = await this.$axios.post(reqUrl, { token, news_id: String(news_id) })
                    this.$message.success( res.data.msg )
                    this.$emit('update')
                } else {
                    this.auth()
                }
                
            },
            // 点赞
            async  zanNews () {
                if ( this.token ) {
                    let { token,news_id } = this 
                    let status = this.isZan == 1 ? 1 : 0
                    let res = await this.$axios.post("/lencon/pc/news/news/zan", { token, news_id: news_id, status })
                    this.$message.success( res.data.msg )
                    this.$emit('update')
                } else {
                    this.auth()
                }
            },
            // 故不能动到顶部
            scrollTop () {
                document.documentElement.scrollTop = 0
            },
            // 展示新闻详情
            showNewsDetail ( item ) {
                this.$router.push({
                    path: `/NewsDetail/${item.newsId}`,
                    query: {
                        cate_id: item.cate_id
                    }
                })
            },
            // 格式化数据
            formatData () {
            
                    this.iconList[1].status = this.isZan
        
 
                    this.iconList[0].status = this.isCollect

   
                    this.iconList[1].count = this.info.zanNum
            
                // console.log( this.info )
            },
        },
        updated() {
            this.formatData()
        },
    }
</script>

<style lang="scss" scoped>
@import "../../assets/css/main.scss";


.detail {
    width: 1200px;
    min-height: 700px;
    margin: 20px auto;
    .box_title {
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 20px;
        border-left: 4px solid #fff;
        margin: 20px 0;
        .box_title_left {
            font-size: 24px;
            font-weight: bold;
        }
        .box_title_right {
            font-size: 14px;
        }
    }
    .content_box {
        width: 1200px;
        padding: 40px;
        background-color: #fff;
        position: relative;
        left: 0;
        top: 0;
        .fixed_box {
            position: fixed;
            top: 370px;
            right: 4%;
            background-color: #fff;
            width: 100px;
            border-radius: 5px;
            // border: 1px solid #EDEDED;
            overflow: hidden;
            box-shadow: 0px 0px 10px #EDEDED;
            
            .item {
                padding: 20px 10px;
                text-align: center;
                cursor: pointer;
                span {
                    font-size: 20px;
                }
                .txt {
                    font-size: 16px;
                }
                .red {
                    color: #2767c4 ;
                    
                }
                .gray {
                    color: #b3b3b3 ;
                }
            }
            .active {
                background-color: #2767c4 ;
                color: #ffffff !important;
                .icon {
                    color: #fff !important;
                }
            }
        }
        .title {
            text-align: center;
            width: 660px;
            font-size: 30px;
            font-weight: bold;
            margin: 0 auto;
            margin-top: 40px;
        }
        .desc {
            font-size: 14px;
            margin: 20px 0;
            color: #B6B6B6;
            display: flex;
            align-items: center;
            justify-content: center;
            border-bottom: 1px solid #eeeeee;
            padding: 20px 0;
            .item {
                margin: 0 10px;
            }
        }
        .news_content {
            width: 900px;
            margin: 0 auto;
        }
    }

    .bottom_box {
        width: 100%;
        display: flex;
        margin: 20px 0;
        align-items: center;
        justify-content: space-between;
        .items {
            width: 535px;
            height: 60px;
            line-height: 60px;
            font-size: 16px;
            background: rgba(238, 238, 238, 0.59);
            border: 1px solid #F1F1F1;
            padding: 0 20px;
            @include SingleRow;
            cursor: pointer;
        }
    }
}
</style>